import { AuthData, PageAccess } from "@/_modulos/login";
import {
  Grupo,
  Filial,
  CondicaoPagamentoRow,
  Usuario,
} from "@apiUser";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";

export type UserStore = {
  user: Usuario | null;
  auth: AuthData | null;
  grupos: Grupo[];
  filiais: Filial[];
  pageAccess: PageAccess | null;
  centrosCusto: Array<{
    cttFilial: string;
    cc: Array<{ CTT_CUSTO: string; CTT_DESC01: string }>;
  }>;
  condicoesPagamento: CondicaoPagamentoRow[];
  setUserData: (data: Partial<UserStore>) => void;
  clear: () => void;
};

export const useUserStore = create<UserStore>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        auth: null,
        grupos: [],
        filiais: [],
        pageAccess: null,
        centrosCusto: [],
        condicoesPagamento: [],
        setUserData: (data: Partial<UserStore>) => set(data),
        clear: () =>
          set({
            user: null,
            auth: null,
            grupos: [],
            filiais: [],
            pageAccess: null,
            centrosCusto: [],
            condicoesPagamento: [],
          }),
      }),
      { name: "user-store" }
    ),
    { name: "auth-store" }
  )
);
